import {roles, permissions} from "../../../assets/constants";


/**
 * Gets the options to use in the table fields and form dropdowns.
 * @returns {options: obj}
 */
export default async function GetOptions(edit) {
  const active = {
    true: "Aktif",
    false: "Aktif Değil",
  };
  return {
    roles,
    permissions,
    active,
  };
}
